module.exports = __webpack_public_path__ + "img/DAVID_CANNON_36-rs.fc131ce3.jpg";